export function setMetalness(materials, amount) {
  for(let mat in materials) {
      materials[mat].metalness = amount;
      materials[mat].emissiveIntensity = 0;
  }
}
